<template>
    <div class="v-status" :class="classes"></div>
</template>

<script>
export default {
    name: 'v-status',

    props: {
        colorByVs: {
            type: String,
            default: 'success'
        },

        dimensions: {
            type: String,
            default: '15px'
        }
    },

    computed: {
        classes() {
            return [
                `v-status__color-${this.colorByVs}`
            ]
        }
    }
}
</script>

<style lang="scss">
.v-status {
    width: v-bind(dimensions);
    height: v-bind(dimensions);
    border-radius: 50px;

    &__color {
        &-success {
            background-color: rgba(var(--vs-success), 1);
        }

        &-danger {
            background-color: rgba(var(--vs-danger), 1);
        }

        &-warning {
            background-color: rgba(var(--vs-warning), 1);
        }
    }
}
</style>
